import { Component } from '@angular/core'

@Component({
	selector: 'page-not-found',
	template: ` <div>Not found</div> `,
})
export class PageNotFoundComponent {}
